import { Link } from "react-router";

const GITHUB_URL = "https://github.com/haporfirio/cyphron";

export function PortfolioNoticePage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--cy-bg, #080C14)",
        color: "var(--cy-ink-100, #F8FAFC)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        fontFamily: "var(--cy-fs-sans, system-ui, sans-serif)",
      }}
    >
      <div style={{ maxWidth: 560, textAlign: "center" }}>
        <h1
          style={{
            fontSize: 28,
            fontWeight: 600,
            marginBottom: 16,
            letterSpacing: "-0.01em",
          }}
        >
          Cyphron is now an open-source portfolio artifact
        </h1>
        <p
          style={{
            fontSize: 15,
            lineHeight: 1.6,
            color: "var(--cy-ink-80, #94A3B8)",
            marginBottom: 28,
          }}
        >
          The application (admin panel and client dashboard) is no longer
          deployed. The full source code, architecture and SDLC artifacts are
          public on GitHub.
        </p>
        <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <a
            href={GITHUB_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
              padding: "12px 22px",
              fontSize: 14,
              fontWeight: 600,
              borderRadius: 999,
              background: "#84FF00",
              color: "#0A1500",
              textDecoration: "none",
              boxShadow:
                "0 0 0 1px rgba(132, 255, 0, 0.35), 0 10px 30px -10px rgba(132, 255, 0, 0.55)",
            }}
          >
            View on GitHub →
          </a>
          <Link
            to="/"
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "12px 22px",
              fontSize: 14,
              fontWeight: 500,
              borderRadius: 999,
              background: "transparent",
              color: "#F8FAFC",
              border: "1px solid rgba(255, 255, 255, 0.18)",
              textDecoration: "none",
            }}
          >
            Back to landing
          </Link>
        </div>
      </div>
    </div>
  );
}
